import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

type TabKey = 'treasures' | 'balance' | 'friends' | 'stake' | 'tasks' | 'games' | 'admin';

type Props = {
  active: TabKey;
  onChange: (tab: TabKey) => void;
  isAdmin?: boolean;
};

const BottomNav = ({ active, onChange, isAdmin = false }: Props) => {
  const { t } = useLanguage();
  
  const item = (key: TabKey, label: string, icon: string) => (
    <button
      className={`flex flex-col items-center text-xs ${active === key ? 'text-yellow-400' : 'text-gray-400'}`}
      onClick={() => onChange(key)}
    >
      <span className="text-xl">{icon}</span>
      <span>{label}</span>
    </button>
  );

  return (
    <nav className="fixed bottom-0 w-full flex justify-around text-white py-2 border-t border-white/10 bg-gradient-to-r from-indigo-500 to-purple-600">
      {item('treasures', t.treasures, '🧰')}
      {item('balance', t.balance, '💰')}
      {item('stake', 'Stake', '💎')}
      {item('tasks', t.tasksTitle || 'Задачи', '📋')}
      {item('friends', t.friends, '👥')}
      {item('games', t.games, '🎮')}
      {isAdmin && item('admin', t.admin, '👨‍💼')}
    </nav>
  );
};

export type { TabKey };
export default BottomNav;
